// extracted by mini-css-extract-plugin
export default {"container":"RightPanel_container__N6nWh","titleBar":"RightPanel_titleBar__jLp-1","tabs":"RightPanel_tabs__Pk08j","active":"RightPanel_active__FaAjB"};